import { useCallback, useContext, useState } from 'react';
import { useOtherSettings } from '@namespace/cms';
import { useGetCurrencySymbol } from '@namespace/common';
import { useI18n } from '@namespace/i18n';
import { useNotifications } from '@namespace/notifications';
import { UserContext } from '@namespace/user';
import { bonusesActions } from '../../store';

const { FETCH_BS_BONUS_DETAILS } = bonusesActions;

export const useBsBonusDetailsFetchCallback = (bonusId) => {
  const [isFetchingDetails, setIsFetchingDetails] = useState(false);
  const [user] = useContext(UserContext);
  const { activeWallet } = user;
  const { currency } = activeWallet;
  const { t } = useI18n();
  const { errorNotification } = useNotifications();
  const { isDisplayCurrencySymbol = false } = useOtherSettings();
  const getCurrencySymbol = useGetCurrencySymbol();

  const fetchBonusDetails = useCallback(async () => {
    try {
      setIsFetchingDetails(true);
      await FETCH_BS_BONUS_DETAILS({
        bonusId,
        currency,
        formattedCurrency: isDisplayCurrencySymbol
          ? getCurrencySymbol(currency)
          : undefined
      });
    } catch {
      errorNotification(t(`accountingMessages.accounting_error_6`));
    } finally {
      setIsFetchingDetails(false);
    }
  }, [
    bonusId,
    currency,
    errorNotification,
    getCurrencySymbol,
    t,
    isDisplayCurrencySymbol
  ]);

  return { fetchBonusDetails, isFetchingDetails };
};
